module.exports = __webpack_public_path__ + "static/img/office-img-3-300x280.4b8b29b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-img-3-300x280.jpg
// module id = swjj
// module chunks = 0